import { render } from "./DateMonthYearField.vue?vue&type=template&id=010a6128"
import script from "./DateMonthYearField.vue?vue&type=script&lang=js"
export * from "./DateMonthYearField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__